import { format, isValid } from 'date-fns'

import { ABS_SHARED } from './../shared-constants'

export const dateUtils = {
  normalizeDate(date: Date): Date {
    const normalized = new Date(date)
    normalized.setHours(12, 0, 0, 0)
    return normalized
  },

  normalizeSeparators(input: string): string {
    return input.replace(/[-\.]/g, '/')
  },

  toRawFormat(date: Date): string {
    return isValid(date) ? format(date, ABS_SHARED.DATES.RAW_DATE_FORMAT) : ''
  },

  rawToISO(rawDateStr: string): string {
    if (!rawDateStr || rawDateStr.length !== 8 || !/^\d{8}$/.test(rawDateStr)) {
      return new Date().toISOString()
    }

    try {
      const year = parseInt(rawDateStr.substring(0, 4), 10)
      const month = parseInt(rawDateStr.substring(4, 6), 10) - 1
      const day = parseInt(rawDateStr.substring(6, 8), 10)

      const dateObj = new Date(year, month, day)
      dateObj.setHours(12, 0, 0, 0)

      return dateObj.toISOString()
    } catch (error) {
      return new Date().toISOString()
    }
  },
}
